import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'bootstrap';
import InspectionList from './InspectionList';
import SectionHeader, { SectionHeaderTypes } from '../../Common/SectionHeader';

export default function InspectionType({ categoryKey, inspectionType, onSelectDoc, viewDoc, downloadDoc, downloadAll }) {
    const [isClosed, setIsClosed] = useState(true);
    const tooltipList = useRef([]);
    useEffect(() => initializeTooltips(inspectionType), [inspectionType]);
    useEffect(() => handleAddResizeEvent(), []);


    function initializeTooltips(inspectionType) {
        const tooltipTriggerList = document.querySelectorAll(`.projectDocType[data-id="${inspectionType.key}"] .nameContainer[data-bs-toggle="tooltip"]`);
        const newTooltipList = [...tooltipTriggerList].map(el => {
            return { element: el, tooltip: new Tooltip(el) };
        });

        tooltipList.current = newTooltipList;

        return () => {
            // Dispose tooltips.
            newTooltipList.map(t => t.tooltip.dispose());
        };
    }

    function handleAddResizeEvent() {
        function handleResize() {
            const newTooltipList = tooltipList.current.map(x => {
                if (x.element.offsetWidth >= x.element.scrollWidth) {
                    x.tooltip.disable();
                }
                else {
                    x.tooltip.enable();
                }
                return x;
            });

            tooltipList.current = newTooltipList;
        }

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }

    let itemCount = `(${inspectionType.documents.length})`;
    let documents = !isClosed && (<InspectionList
        categoryKey={categoryKey}
        inspectionTypeKey={inspectionType.key}
        selected={inspectionType.selected}
        documentList={inspectionType.documents}
        onSelectDoc={onSelectDoc}
        viewDoc={viewDoc}
        downloadDoc={downloadDoc}
        downloadAll={downloadAll} />);

    let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    let inspectionTypeName = inspectionType && (<SectionHeader sectionHeaderType={SectionHeaderTypes.Secondary} classes="justify-between mb-1">
        <span className="nameContainer w-full cursor-pointer"
            onClick={() => setIsClosed(!isClosed)}
            data-bs-toggle="tooltip" data-bs-placement="top"
            data-bs-title={`${inspectionType.inspectionTypeName}`}>
            <span className="name">{inspectionType.key === "npdes" ? "Other" : inspectionType.inspectionTypeName} {itemCount}</span>
        </span>
        <i className={`cursor-pointer ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />
    </SectionHeader>);

    return (
        <div className="inspectionTypeContainer">
            {inspectionTypeName}
            {documents}
        </div>
    );
}